export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";